import React from 'react';
import { Field } from 'formik';
import styles from '../AddEditTransactions/TransactionFieldGroup.module.css';
import { useCurrencies } from '../../pages/Settings/CurrencyContext';

function TransactionFieldGroup( {index, transaction, errors, rawCategories, categoriesLoading, showHeading = true} ) {
    const { currencySymbol } = useCurrencies();
    
    const filteredCategories = transaction.type 
        ? rawCategories.filter(cat => cat.type === transaction.type)
        : rawCategories;
                        
    return(
        <div key={index} className= {styles.fieldsDiv}>
            {showHeading && (
                <h3 className={styles.heading}>Transaction #{index + 1}</h3>
            )}

            <label className= {styles.label} htmlFor="AmountInput">Amount:</label>
            <div className={styles.inputWrapper}>
                <span className={styles.currencySymbol}>{currencySymbol}</span>
                <Field className = {`${styles.fieldInput} ${styles.textInput}`} id= {`amount-${index}`} name= {`transactions.${index}.amount`} placeholder= "0.00"/>
            </div>
            {errors.transactions?.[index]?.amount && (
                <span className={styles.error}>{errors.transactions[index].amount}</span>
            )}

            <label className= {styles.label} htmlFor="CounterpartyInput">Counterparty:</label>
            <Field className = {styles.fieldInput} id= {`counterparty-${index}`} name= {`transactions.${index}.counterparty`} placeholder= "Counterparty"/>
            {errors.transactions?.[index]?.counterparty && (
                <span className={styles.error}>{errors.transactions[index].counterparty}</span>
            )}

            <label className= {styles.label} htmlFor="TypeInput">Type:</label>
            <Field className = {styles.fieldInput} id= {`type-${index}`} name= {`transactions.${index}.type`} as="select">
                <option value="income">Income</option>
                <option value="expense">Expense</option>
            </Field>  
            {errors.transactions?.[index]?.type && (
                <span className={styles.error}>{errors.transactions[index].type}</span>
            )}

            <label className= {styles.label} htmlFor="CategoryInput">Category:</label>
            <Field className= {styles.fieldInput} id= {`category-${index}`} name= {`transactions.${index}.category`} as="select" disabled={categoriesLoading}>
                {categoriesLoading ? (
                    <option>Loading...</option>
                ) : (
                <>
                    <option value= "" hidden>Select a Category</option>
                    {filteredCategories.map(cat => (
                        <option key={cat.categoryId} value={cat.categoryId}>{cat.name}</option>
                    ))}
                </>
                    )}
            </Field> 
            {errors.transactions?.[index]?.category && (
                <span className={styles.error}>{errors.transactions[index].category}</span>
            )}

            <label className= {styles.label} htmlFor="DateInput">Date:</label>
            <Field className = {styles.fieldInput} id= {`date-${index}`} name= {`transactions.${index}.date`} type= "date" placeholder= "Date"/>
            {errors.transactions?.[index]?.date && (
                <span className={styles.error}>{errors.transactions[index].date}</span>
            )}
        </div>
    );
};

export default TransactionFieldGroup;